import { ShieldCheck } from 'lucide-react';

/**
 * Le bandeau du canal ④ : ce logement a déjà un mandat signé.
 *
 * Sorti de la page d'onboarding pour ne pas la faire déborder, et parce qu'il porte
 * une décision à lui seul : à partir du moment où il s'affiche, la signature ne sera
 * PAS redemandée. Un client qui a déjà signé et à qui on refait signer produit un
 * second mandat concurrent sur le même point de livraison.
 *
 * Le nom arrive masqué du serveur (« Jean D. ») et il est affiché tel quel. Il est là
 * pour que le poseur CONFIRME devant le client qu'on parle bien du bon dossier, pas
 * pour lui apprendre qui habite ici : la route est ouverte à tout internet, et un nom
 * complet en ferait un annuaire qu'on interroge point de livraison par point de
 * livraison.
 */
export default function BandeauMandatExistant({ mandat }) {
  if (!mandat) return null;
  return (
    <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-3 flex items-start gap-2"
         data-testid="onb-bandeau-mandat">
      <ShieldCheck className="w-4 h-4 text-emerald-600 mt-0.5 shrink-0" />
      <div>
        <p className="text-[12px] font-medium text-emerald-800">
          Mandat déjà validé · {mandat.nom_masque}
        </p>
        <p className="text-[11px] text-emerald-700 leading-snug mt-0.5">
          Ce logement a déjà un mandat signé : il n'y a ni consentements ni signature à
          reprendre. Il reste à rattacher l'équipement au dossier.
        </p>
      </div>
    </div>
  );
}
